export default "__VITE_ASSET__D_M7QTOQ__"